import React from 'react';
import { IProps, IState } from './types';
import PolicyInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyInfo';
import VehicalInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/VehicalInfo';
import InsuredContent from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredContent';
import PolicyholderInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyholderInfo';
import InsuredInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredInfo';
import PaymentInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PaymentInfo';
import { RouterSettings } from 'constants/models/routerSettings';
import { DetailVehicleContent, InsuredDataVehicleContentInfo, ItemDataContent } from 'bff/models/member';
import _ from 'lodash';
import commonService from 'utils/commonService';
import MobileDeviceInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/MobileDeviceInfo';
import { connect } from 'react-redux';
import { RootReducersState } from 'redux/reducers';

class PolicyDetailMobileDevice extends React.Component<IProps, IState> {
  state: IState = {
    detailInfo: {
      APPLICANT_DATA: {
        ADDRESS: {
          ADDRESS: '',
          AREA_ID: '',
          CITY_ID: '',
          FULL: '',
          POST_CODE: ''
        },
        BIRTHDAY: '',
        EMAIL: '',
        GENDER: '',
        ID: '',
        MOBILE: '',
        NAME: '',
        NATIVE: ''
      },
      AVAILABLE_ACTION: {
        ACTIONS: new Array(0),
        ACTION_URL: ''
      },
      INSURED_DATA: {
        NATIVE: '',
        ID: '',
        NAME: '',
        GENDER: '',
        BIRTHDAY: '',
        MOBILE: '',
        EMAIL: ''
      },
      PAYMENT_DATA: {
        AMOUNT: 0,
        APPROVE_CODE: '',
        BANK: '',
        BANK_ACCOUNT: '',
        CARD_NO: '',
        PAYER_ID: '',
        PAYER_NAME: '',
        PAY_BY: '',
        TRANSACTION: ''
      },
      POLICY_DATA: {
        APPLY_NO: '',
        APPLY_TIME: '',
        BC_TYPE: '',
        CONFLICT_STATUS: '',
        DEPARTMENT: '',
        OPERATOR: '',
        PAYMENT_STATUS: '',
        POLICY_DELIVERY: '',
        POLICY_NO: '',
        POLICY_STATUS: '',
        PROGRAM_ID: '',
        PURCHASE_DATE: ''
      },
      POLICY_INFO: {
        START_DATE: '',
        /** 保險期間-結束日 */
        END_DATE: '',
        /** 總保費 */
        TOTAL_FEE: '',
        /** 承保內容 Array */
        ITEM_DATA: new Array(0)
      },
      RENEWAL_INFO: {
        /** IMEI/序號 */
        IMEI_SN: '',
        /** 保單號碼 */
        REPOLICY_NO: ''
      },
      MOBILE_DEVICE_DATA: {
        /** 類型 */
        DEVICE_TYPE: '',
        /** 類型名稱 */
        DEVICE_TYPE_NAME: '',
        /** 廠牌 */
        VENDOR_NAME: '',
        /** 型號 */
        MODEL: '',
        /** 容量 */
        STORAGE_SIZE: '',
        /** 官方售價 */
        VPRICE: '',
        /** 目前售價 */
        MPRICE: '',
        /** IMEI/序號 */
        IMEI_SN: '',
        /** 手機號碼(欲投保之手機號碼) */
        TARGET_PHONE_NO: ''
      },
      KYC_DATA: new Array(0),
      OPERATION_LOG: new Array(0)
    },
    insTypeId: ''
  }

  private insType = this.props.route && this.props.route.insType;

  componentDidMount () {
    let detailInfoVal;
    let insTypeIdVal;
    if (this.props.history.location.state) {
      // 透過路由取得險種類別
      const { detailInfo, insTypeId }: any = this.props.history.location.state;
      detailInfoVal = detailInfo;
      insTypeIdVal = insTypeId;
    }
    // console.log('detailInfoVal', detailInfoVal);
    if (!detailInfoVal || !insTypeIdVal) {
      this.props.history.replace(RouterSettings.MemberCenter.PolicyInquiry);
      return;
    }

    this.setState({
      detailInfo: { ...detailInfoVal },
      insTypeId: insTypeIdVal
    });
  }

  render () {
    const { POLICY_DATA, MOBILE_DEVICE_DATA, POLICY_INFO, APPLICANT_DATA, INSURED_DATA, PAYMENT_DATA } = this.state.detailInfo;
    return (
      <div className={`policy-detail policy-detail--${this.insType}`}>
        <div className="template-container">
          <div className="template-content">
            <div className="policy-detail__content">
              {/* 保單資訊 */}
              {
                POLICY_DATA && (
                  <PolicyInfo {...POLICY_DATA} />
                )
              }
              {/* 行動裝置資料 */}
              {
                MOBILE_DEVICE_DATA && (
                  <MobileDeviceInfo {...MOBILE_DEVICE_DATA} />
                )
              }
              {/* 投保内容 */}
              {
                POLICY_INFO && (
                  <InsuredContent collapsible>
                    <InsuredContent.List
                      INS_TYPE_ID={this.state.insTypeId}
                      MOBILE_START_DATE={POLICY_INFO.START_DATE}
                      MOBILE_END_DATE={POLICY_INFO.END_DATE}
                    />
                    <InsuredContent.Table
                      INS_TYPE_ID={this.state.insTypeId}
                      TOTAL_FEE={commonService.thousandFormat(`${POLICY_INFO.TOTAL_FEE}`)}
                      DATA={POLICY_INFO.ITEM_DATA && [
                        {
                          CHILD_DATA: _.map(POLICY_INFO.ITEM_DATA, (content: ItemDataContent) => {
                            return {
                              ITEM_NAME: content.TEXT,
                              ITEM_AMT: '',
                              DISCOUNT_AMT: content.VALUE
                            };
                          })
                        }
                      ]}
                    />
                  </InsuredContent>
                )
              }
              {/* 要保人資料 */}
              {
                APPLICANT_DATA && (
                  <PolicyholderInfo {...APPLICANT_DATA} ADDRESS={APPLICANT_DATA.ADDRESS.FULL} InsTypeId={this.state.insTypeId} />
                )
              }

              {/* 被保險人資料 */}
              {INSURED_DATA && (
                <InsuredInfo
                  InsTypeId={this.state.insTypeId}
                  DATA={[{
                    NATIVE: INSURED_DATA.NATIVE,
                    ID: INSURED_DATA.ID,
                    NAME: INSURED_DATA.NAME,
                    GENDER: INSURED_DATA.GENDER,
                    BIRTHDAY: INSURED_DATA.BIRTHDAY,
                    MOBILE: INSURED_DATA.MOBILE,
                    EMAIL_ADDR: INSURED_DATA.EMAIL,
                    // 行動裝置險 被保人地址同要保人地址
                    ADDRESS: APPLICANT_DATA.ADDRESS.FULL
                  }]}
                />
              )}
              {/* 付款資訊 */}
              <PaymentInfo {...PAYMENT_DATA} />
            </div>
            <div className="policy-detail__controls">
              <button type="button" className="policy-detail__btn" onClick={() => this.props.history.push(RouterSettings.MemberCenter.PolicyInquiry)}>{commonService.getNameByLng(this.props.resources, 'TID_Back_to_policy_query')}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    resources: state.resources
  };
};

export default connect(mapStateToProps)(PolicyDetailMobileDevice);
